export const WarningTriangleIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 24 24" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
    <line stroke="currentColor" strokeLinecap="round" strokeWidth={2} x1={12} x2={12} y1={9} y2={13} />
    <line stroke="currentColor" strokeLinecap="round" strokeWidth={2} x1={12} x2={12.01} y1={17} y2={17} />
  </svg>
);
